export default __webpack_public_path__ + "static/media/header-people-active.da50c2c8.svg";